export default "__VITE_ASSET__Bs8KflyA__"